module.exports = __webpack_public_path__ + "static/media/pf.ab6b0fb6.svg";